import { render, staticRenderFns } from "./AutomazioneAssignments.vue?vue&type=template&id=484a4df8&scoped=true&"
import script from "./AutomazioneAssignments.vue?vue&type=script&lang=js&"
export * from "./AutomazioneAssignments.vue?vue&type=script&lang=js&"
import style0 from "./AutomazioneAssignments.vue?vue&type=style&index=0&id=484a4df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a4df8",
  null
  
)

export default component.exports